exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-main .profile-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.profile-main .profile-content .profile-button {\n  display: flex;\n}\n@media only screen and (max-width: 768px) {\n  .profile-main .profile-content .profile-button a {\n    width: 100%;\n  }\n  .profile-main .profile-content .profile-button a + button {\n    width: calc(100% - 20px);\n    margin-right: 0;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-3-1!./node_modules/less-loader/dist/cjs.js??ref--1-oneOf-3-2!./src/pages/ChannelPage/ChannelPage.less
// module id = 1468
// module chunks = 0